export default __webpack_public_path__ + "6594ce0f641d2bb9a99f1d8ce6dff62d.woff2";